module.exports = __webpack_public_path__ + "static/media/login-background.56412680.jpeg";